var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.32 2.56h-4.434c-.331 0-.6.269-.6.6 0 .331.269.6.6.6h2.985l-4.81 4.81c-.234.234-.234.614 0 .848.235.234.615.235.85 0l4.809-4.81v2.986c0 .331.269.6.6.6.331 0 .6-.269.6-.6V3.16c0-.327-.265-.6-.6-.6zM9.418 11.062c-.234-.234-.614-.235-.848 0l-4.81 4.81v-2.986c0-.331-.269-.6-.6-.6-.331 0-.6.269-.6.6v4.434c0 .326.266.6.6.6h4.434c.331 0 .6-.269.6-.6 0-.331-.269-.6-.6-.6H4.609l4.81-4.81c.234-.234.234-.614 0-.848z",
    transform: "translate(-840.000000, -149.000000) translate(202.000000, 120.000000) translate(633.000000, 24.000000) translate(5.760000, 5.760000) translate(-0.000000, -0.000000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSize);
export default __webpack_public_path__ + "static/media/full-size.5087ce53.svg";
export { ForwardRef as ReactComponent };